import { Controller } from "@hotwired/stimulus"

// A Merges card's Help panel: puts the names it found into the card's boxes
// (the name after merging, each figure's option), before its Do this
// submits the card, or on their own to check first.
export default class extends Controller {
  static values = { form: String }

  fill({ params: { fill } }) {
    // A box the card hasn't got (a card not offered as options) is added here, hidden, to the card's form.
    const set = (selector, value, name) => {
      if (!value) return
      let input = document.querySelector(selector)
      if (!input && name) {
        input = Object.assign(document.createElement("input"), { type: "hidden", name })
        input.setAttribute("form", this.formValue)
        this.element.append(input)
      }
      if (!input) return
      input.value = value
      input.dispatchEvent(new Event("input", { bubbles: true }))
    }
    set(`input[name='name'][form='${this.formValue}']`, fill.name)
    Object.entries(fill.options || {}).forEach(([id, name]) => set(`input[name='names[${id}]'][form='${this.formValue}']`, name, `names[${id}]`))
  }
}
